import Icon from '../components/Icon.vue'

Icon.register({"window-maximize":{"width":512,"height":512,"paths":[{"d":"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM448 192H64V108C64 101.4 69.4 96 76 96H436C442.6 96 448 101.4 448 108V192z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/window-maximize.js